import React from 'react';
import SweetAlert from 'sweetalert-react';
import OrdersList from '../controls/OrdersList.jsx';
import OrdersSearch from "../controls/OrdersSearch.jsx";
import 'sweetalert/dist/sweetalert.css';

import AdminPageTypes from '../AdminPageTypes';
import Format from '../../utils/Formatter';

class BuscaPedido extends React.Component {

    render() {
        return (
            <OrdersSearch
                orders={this.props.caixa.abertos}
                onSelectOrder={(orderId) => this.props.events.onSelectOpenOrder(orderId, this.props.token)}
                selectedOrder={this.props.caixa.selecionada}
                idClienteName="idClienteCaixa"
                idClienteCaixa={this.props.caixa.idClienteCaixa}
                cpfClienteName="cpfClienteCaixa"
                cpfClienteCaixa={this.props.caixa.cpfClienteCaixa}
                showQrPreviewName="showQrPreviewCaixa"
                showQrPreviewCaixa={this.props.caixa.showQrPreviewCaixa}
                onUpdateValue={this.props.events.onUpdateText}
                onShowDialog={this.props.events.onShowDialog}
                onRefresh={() => this.props.events.onUpdateOrdersLists(this.props.token)}
            />
        );
    }
}

class ConteudoPedido extends React.Component {

    componentWillUpdate() {
        $('.discountInput').unmask();
    }

    componentDidUpdate() {
        $('.discountInput').mask("#.##0,00", {reverse: true});
    }

    componentWillUnmount() {
        $('.discountInput').unmask();
    }

    render() {
        const selectedOrder = this.props.caixa.selecionada;
        const token = this.props.token;
        const editable = this.props.caixa.pedidoEditavel;

        const buildUpdate = (produto_id, desconto, quantidade) => ({produto_id, desconto, quantidade});
        const onAddCartItemToCart = (product) => {
            const update = buildUpdate(product.id_produto, product.desconto, product.quantidade + 1);
            this.props.events.onUpdateCartItems(selectedOrder.id, [update], token)
        };
        const isLastItemType = selectedOrder.items.length === 1;
        const isLastItem = (product) => product.quantidade === 1 && isLastItemType;
        const onRemoveItemFromCart = (product) => {
            if (isLastItem(product)) {
                this.props.events.onShowDialog("Erro!", "Carrinho não pode ser esvaziado completamente.");
                return;
            }
            const update = buildUpdate(product.id_produto, product.desconto, product.quantidade - 1);
            this.props.events.onUpdateCartItems(selectedOrder.id, [update], token)
        };
        const onDeleteItemFromCart = (product) => {
            if (isLastItemType) {
                this.props.events.onShowDialog("Erro!", "Carrinho não pode ser esvaziado completamente.");
                return;
            }
            const update = buildUpdate(product.id_produto, product.desconto, 0);
            this.props.events.onUpdateCartItems(selectedOrder.id, [update], token)
        };
        const onDiscountChanged = (e, product) => {
            const descontoDigitado = "" === $(e.target).cleanVal() ? 0 : $(e.target).cleanVal() / 100.0;
            const valorMaximo = product.quantidade * product.preco;
            const desconto = (descontoDigitado > valorMaximo) ? valorMaximo : descontoDigitado;

            const newVal = Object.assign({}, this.props.caixa.descontosEditadosCaixa, {[product.id_produto]: desconto.toFixed(2)});
            this.props.events.onUpdateText('descontosEditadosCaixa', newVal);
        };

        return (
            <div className="form-group">
              <label>Itens do pedido</label>
              <div className="table-responsive">
                  <table className="table">
                      <thead>
                          <tr>
                              <th style={{"width": "30%"}}>Nome</th>
                              <th>Valor</th>
                              <th>Qtd</th>
                              <th/>
                              <th style={{"width": "10%"}}>Desconto</th>
                          </tr>
                      </thead>
                      <tbody>
                          {selectedOrder.items.map(i => (
                            <tr key={i.id_produto}>
                                <td>{i.descricao}</td>
                                <td>{Format.money(i.preco)}</td>
                                <td>{i.quantidade}</td>
                                <td>
                                    <button type="button" className="btn btn-sm btn-default" onClick={() => onAddCartItemToCart(i)} tabIndex="-1" disabled={!editable}>
                                      <i className="glyphicon glyphicon-plus"/>
                                    </button>
                                    <button type="button" className="btn btn-sm btn-default" onClick={() => onRemoveItemFromCart(i)} tabIndex="-1" disabled={!editable}>
                                      <i className="glyphicon glyphicon-minus"/>
                                    </button>
                                    <button type="button" className="btn btn-sm btn-danger" onClick={() => onDeleteItemFromCart(i)} tabIndex="-1" disabled={!editable}>
                                      <i className="glyphicon glyphicon-trash"/>
                                    </button>
                                </td>
                                <td>
                                    <input type="text" style={{"width": "100px"}}
                                        className="form-control discountInput"
                                        value={this.props.caixa.descontosEditadosCaixa[i.id_produto] || i.desconto}
                                        disabled={!editable}
                                        onChange={(e) => onDiscountChanged(e, i)} tabIndex="-1" />
                                </td>
                            </tr>
                          ))}
                      </tbody>
                  </table>
              </div>
            </div>
        );
    }
}

class Pagamento extends React.Component {

    componentWillUpdate() {
        $('.paymentInput').unmask();
    }

    componentDidUpdate() {
        $('.paymentInput').mask("#.##0,00", {reverse: true});
    }

    componentWillUnmount() {
        $('.paymentInput').unmask();
    }

    render() {
        const paymentMethods = this.props.caixa.pagamentos;
        const total = this.props.caixa.total;
        const totalMatch = total === this.props.caixa.payment.map(p => p.id_forma_pagamento !== -1 ? p.valor : 0).reduce((a, b) => a + b, 0) ;

        const isAlreadyIncluded = (id) =>
            this.props.caixa.payment.find((p) => p.id_forma_pagamento === id);
        const paymentDescription = (id) =>
            paymentMethods.find(p => p.id_forma_pagamento === id).descricao;
        const onAddMethod = (id_forma_pagamento) => {
            if (isAlreadyIncluded(id_forma_pagamento)) {
                return;
            }
            const value = Math.max(0, total - this.props.caixa.payment.map(p => p.valor).reduce((a, b) => a + b, 0));
            const payment = this.props.caixa.payment.concat({id_forma_pagamento: id_forma_pagamento, valor: value});
            this.props.events.onUpdatePayment(payment);
        };
        const onRemoveMethod = (index) => {
            const payment = this.props.caixa.payment.slice();
            payment.splice(index, 1);
            this.props.events.onUpdatePayment(payment);
        };
        const onChangeMethodValue = (e, index) => {
            const payment = this.props.caixa.payment.slice();
            payment[index].valor = $(e.target).cleanVal() / 100;
            this.props.events.onUpdatePayment(payment);
        };

        const paymentOptions = this.props.caixa.payment.map((p, index) => (
            <div className={"row" + (totalMatch ? "" : " has-error")} key={index}>
                <div className="col-sm-7">
                    <div className="input-group">
                        <span className="input-group-addon">R$</span>
                        <input type="text"
                            className="form-control paymentInput"
                            onChange={(e) => onChangeMethodValue(e, index)}
                            value={p.valor.toFixed(2)} />
                        <span className="input-group-addon">{paymentDescription(p.id_forma_pagamento)}</span>
                        <span className="input-group-btn">
                            <button className="btn btn-default" onClick={() => onRemoveMethod(index)}>
                                <span className="glyphicon glyphicon-trash" />
                            </button>
                        </span>
                    </div>
                </div>
            </div>
        ));

        return (
            <div>
                <div className="row">
                    <div className="col-xs-12">
                        <label className="control-label" style={{"paddingLeft": "0px"}}>Pagamento</label>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="btn-group">
                            {paymentMethods.map(pm => (
                                <button type="button"
                                        className={"btn btn-default " + (isAlreadyIncluded(pm.id_forma_pagamento) ? "active" : "")}
                                        onClick={() => onAddMethod(pm.id_forma_pagamento)}
                                        key={pm.id_forma_pagamento}>
                                    {pm.descricao}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
                {paymentOptions}
            </div>
        );
    }
}

class Pedido extends React.Component {

    render() {
        const selectedOrder = this.props.caixa.selecionada;
        const total = this.props.caixa.total;
        const token = this.props.token;
        const editable = this.props.caixa.pedidoEditavel;
        const canCloseOrder = total >= 0 && total === this.props.caixa.payment.map(p => p.id_forma_pagamento !== -1 ? p.valor : 0).reduce((a, b) => a + b, 0);

        const onSuccess = () => {
            this.props.events.onCloseSwal();
            this.props.events.onUpdateText('currentPage', AdminPageTypes.VENDA);
        };

        const onCancelOrder = () => {
            this.props.events.onSelectOpenOrder(null, token);
            if (this.props.app.adminPage !== AdminPageTypes.CAIXA) {
                this.props.events.onUpdateText('currentPage', AdminPageTypes.VENDA);
            }
        };
        const onCloseOrder = () => {
            const orderId = selectedOrder.id;
            let promise = this.props.events.onShowSwal("Aguarde", "Seu pedido está sendo processado.");

            const update = selectedOrder.items
                .filter(item => this.props.caixa.descontosEditadosCaixa[item.id_produto] !== undefined)
                .map(item => ({produto_id: item.id_produto, desconto: this.props.caixa.descontosEditadosCaixa[item.id_produto], quantidade: item.quantidade}));
            if (update.length !== 0)
                promise = promise.then(() => this.props.events.onUpdateCartItems(selectedOrder.id, update, token));

            promise = promise.then(() => this.props.events.onCloseOrder(orderId, this.props.caixa.payment, token));
            promise.catch(() => this.props.events.onShowSwal("Erro!", "Ocorreu um erro. Por favor, tente novamente.", this.props.events.onCloseSwal));
            if (this.props.app.adminPage === AdminPageTypes.CAIXA) {
                promise.then(() => this.props.events.onShowSwal("Sucesso!", "O pedido foi devidamente finalizado.", this.props.events.onCloseSwal));
            } else if (this.props.app.adminPage === AdminPageTypes.VENDA_CAIXA) {
                // promise = promise.then(() => this.props.events.onUpdateText('currentPage', AdminPageTypes.VENDA));
                promise.then(() => this.props.events.onShowSwal("Sucesso!", "O pedido foi devidamente finalizado.", onSuccess));

            } else {
                promise = promise.then(() => this.props.events.onUpdateOrdersLists(this.props.token));
                promise = promise.then(() => this.props.events.onSelectClosedOrder(orderId, this.props.token));
                promise = promise.then(() => this.props.events.onUpdateText('currentPage', AdminPageTypes.EXPEDICAO));
            }
        };
        const onEditOrder = () => {
            this.props.events.onUpdateText('pedidoEditavel', true);
        };

        const totalPanel = (
            <div className="form-group">
                  <label>Valor total</label>
                  <p><mark style={{"fontSize": "18px"}}>{Format.money(total)}</mark></p>
            </div>
        );
        const footer = (
            <div className="btn-toolbar">
                <button type="button" className="btn btn-primary" disabled={!canCloseOrder} onClick={onCloseOrder}>
                    <span className="glyphicon glyphicon-ok"></span> Finalizar Pedido
                </button>
                <button type="button" className="btn btn-info" onClick={onEditOrder} disabled={editable}>
                    <span className="glyphicon glyphicon-pencil"></span> Editar
                </button>
                <button type="button" className="btn btn-danger" onClick={onCancelOrder}>
                    <span className="glyphicon glyphicon-remove"></span> Cancelar
                </button>
            </div>
        );
        const clientNameAppendix = selectedOrder ? " - " + selectedOrder.nome : "";

        return (
          <div className="panel panel-color panel-primary js-panel-resp">
              <div className="panel-heading">
                  <h3 className="panel-title">{"Pedido do cliente" + clientNameAppendix}</h3>
              </div>
                <div className="panel-body js-panel-body-w-footer">
                    <BuscaPedido {...this.props} />
                    {selectedOrder && <ConteudoPedido {...this.props} />}
                    {selectedOrder && totalPanel}
                    {selectedOrder && <Pagamento {...this.props} />}
                </div>
              {selectedOrder &&
                <div className="panel-footer">
                    {footer}
                </div>
              }
          </div>
        );
    }
}

class PedidosAbertos extends React.Component {

    render() {
      const onConfirm = (cartId) => {
          this.props.events.onCloseSwal();
          this.props.events.onDeleteCart(cartId, this.props.token);
      };
      const onClickRemove = (cartId) => {
          this.props.events.onShowSwal("Confirmar ação", "O pedido será deletado.", () => onConfirm(cartId), this.props.events.onCloseSwal);
      };

      return (
          <OrdersList
              title={"Pedidos abertos"}
              onRefresh={() => this.props.events.onUpdateOrdersLists(this.props.token)}
              orders={this.props.caixa.abertos}
              cpf={this.props.caixa.cpfClienteCaixa}
              selectedOrder={this.props.caixa.selecionada}
              onSelectOrder={(orderId) => this.props.events.onSelectOpenOrder(orderId, this.props.token)}
              noOrderText={"Nenhuma ordem em aberto"}
              badgeType={"bg-danger"}
              badgeGlyph={"glyphicon glyphicon-trash"}
              onClickBadge={onClickRemove}
              lastOrder={this.props.caixa.lastOrder}
              onPrintLastOrder={() => this.props.events.onPrintOrder(this.props.caixa.lastOrder.id, this.props.token, 'receipt')}
          />
      );
    }
}

class LojaCaixa extends React.Component {

    render() {
        const adminPage = this.props.app.adminPage;
        const showOpenOrders = AdminPageTypes.VENDA_CAIXA !== adminPage && AdminPageTypes.VENDA_CAIXA_EXPEDICAO !== adminPage;

        return (
          <div className="wraper container-fluid">
              <div className="row">
                  <div className={showOpenOrders ? "col-lg-7" : "col-lg-12"}>
                      <Pedido {...this.props} />
                  </div>
                  {showOpenOrders &&
                      <div className="col-lg-5">
                          <PedidosAbertos {...this.props} />
                      </div>
                  }
              </div>
              <SweetAlert
                  show={this.props.caixa.confirm}
                  title={this.props.caixa.title}
                  text={this.props.caixa.text}
                  showConfirmButton={!!this.props.caixa.onConfirm}
                  onConfirm={this.props.caixa.onConfirm}
                  showCancelButton={!!this.props.caixa.onCancel}
                  onCancel={this.props.caixa.onCancel}
                  cancelButtonText="Cancelar"
              />
          </div>
        );
    }
}

export default LojaCaixa;



// WEBPACK FOOTER //
// src/views/pages/LojaCaixa.jsx